import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthContext } from './context/AuthContext';
import Loading from './Components/Hooks/Loading';
import './App.css';
import StopSkill from './fragments/StopSkill';
// import Home from './fragments/Home';
import Settings from './fragments/Settings';
import Loginpage from './fragments/Login';
import Registerpage from './fragments/RegisterPage';
import RegisterIntro from './fragments/RegisterIntro';
import Breath from './fragments/Breath';
// import ToolBox from './fragments/FavoriteActivities.js';
import QuickCope from './fragments/QuickCope';
import Profile from './Components/Profile/EditProfile';
// import Form from './fragments/Form';
import ChooseOption from './fragments/ChooseOption.js';
// import RecommendedSkills from './Components/Skills/RecommendedSkills.js';
// import FilterSkills from './Components/Skills/FilterSkills.js';
// import Featured from './Components/Skills/Featured.js';
import Recommendations from './fragments/Recommended.js';
import Liked from './Components/Skills/Liked.js';
import Activities from './fragments/Activities.js';
import Welcome from './fragments/Welcome.js';
import RCA from './fragments/RootCauseAnalysis.js';
import PaymentCancel from './fragments/PaymentCancel.js';
import PaymentSuccess from './fragments/PaymentSuccess.js';
import ForgotPassword from './Components/Login/ForgetPassword.js';
import ResetPassword from './Components/Login/ResetPassword.js';
import Dashboard from './MyAccount/dashboard.js';
import SubscriptionDetails from './MyAccount/subscriptionDetails.js';
import Subscription from './MyAccount/subscription.js';
import GoPremium from './fragments/GoPremium.js';
// import BillingAdress from './MyAccount/billingAddress.js';
import OrderDetails from './MyAccount/orderDetails.js';
import OrderThankYou from './MyAccount/OrderThanYou.js';
import FavoriteActivities from './fragments/FavoriteActivities.js';
import APIProvider from './Components/AuthProvider/FetchAPIProvider.jsx';
import Pages from './fragments/Pages.js';
// import Page from './fragments/Page.js';
import Api from './context/API/api.js';
// import FetchApi from './context/API/FetchApi.js';
import RCAO from './fragments/RCA.js';
import BreathingBox from './Components/BreathBox/BreathingBox.js';
import IntroScreen from './fragments/IntroScreen.js';
import NotFound from './fragments/NotFound.js';
import EmailTest from './fragments/EmailTest.js';
// import FetchApi from './context/API/FetchApi.js';



// Gate for routes that require an active trial or subscription
const ActivityGuard = ({ children }) => {
  const { user, isSubscribed, isTrialActive } = useAuthContext();
  if (!user) return <Loginpage />;
  // Users with no trialEndsAt are legacy/grandfathered — let them through for now
  if (user.trialEndsAt && !isTrialActive && !isSubscribed) {
    return <Navigate to="/go-premium" replace />;
  }
  return children;
};

function App() {
  const { user, isLoading } = useAuthContext();

  if (isLoading) {
    return <Loading />;
  }

  return (

    <div className="App">
    <Api>
      <Routes>
        <Route path="/api-provider" element={<APIProvider />}></Route>
        <Route path="/rcao" element={<ActivityGuard><RCAO /></ActivityGuard>}></Route>
        <Route path="/ChooseOption" element={<ActivityGuard><ChooseOption /></ActivityGuard>}></Route>

        <Route path="/my-account/order-thank-you" element={user ? <OrderThankYou /> : <Loginpage />}></Route>

        <Route path="/dashboard" element={user ? <Dashboard /> : <Loginpage />}></Route>

        <Route path="/dashboard/subscription" element={user ? <Subscription /> : <Loginpage />}></Route>

        {/* <Route path="/b" element={user ? <BillingAdress /> : <Loginpage />}></Route> */}

        <Route path="/subscriptions/:id" element={user ? <SubscriptionDetails /> : <Loginpage />}></Route>

        <Route path="/orders/:id" element={user ? <OrderDetails /> : <Loginpage />}></Route>

        <Route path="/PaymentSuccess" element={user ? <PaymentSuccess /> : <Loginpage />}></Route>

        <Route path="/Subscription" element={user ? <GoPremium /> : <Loginpage />}></Route>

        <Route path="/go-premium" element={user ? <GoPremium /> : <Loginpage />}></Route>

        <Route path="/PaymentCancel" element={user ? <PaymentCancel /> : <Loginpage />}></Route>

        <Route path="/" element={user ? <ChooseOption /> : <Welcome />}></Route>

        <Route path="/intro" element={<ActivityGuard><IntroScreen /></ActivityGuard>}></Route>

         <Route path="/welcome" element={<Welcome />}></Route>
{/* 
        <Route path="/">
          <Route index element={<Pages />} />
          <Route element={<Page />}>
            <Route path="pages/:welcome" element={<Welcome />} />
            <Route path="pages/:choose-option" element={<ChooseOption />} />
          </Route>
        </Route> */}

        <Route path="/forgot-password" element={<ForgotPassword />}></Route>

        <Route path="/reset-password" element={<ResetPassword />}></Route>

        <Route path="StopSkill" element={<ActivityGuard><StopSkill /></ActivityGuard>}></Route>

        <Route path="Settings" element={<ActivityGuard><Settings /></ActivityGuard>}></Route>

        <Route path="Login" element={<Loginpage/>}></Route>

        <Route path="Breath" element={<BreathingBox />}> </Route>

        <Route path="pages/:slug" element={<Pages/>}></Route>

        <Route path="chain-analysis" element={<ActivityGuard><RCA /></ActivityGuard>}></Route>

        <Route path="Liked" element={<ActivityGuard><Liked /></ActivityGuard>}></Route>

        <Route path="QuickCope" element={<ActivityGuard><QuickCope /></ActivityGuard>}></Route>

        <Route path="Recommended" element={<ActivityGuard><Recommendations /></ActivityGuard>}></Route>

        <Route path="Profile" element={<ActivityGuard><Profile /></ActivityGuard>}></Route>

        <Route path="Activities" element={<ActivityGuard><Activities /></ActivityGuard>}></Route>

        <Route path="favorite-activities" element={<ActivityGuard><FavoriteActivities /></ActivityGuard>}></Route>

        <Route path="register-intro" element={<RegisterIntro />}></Route>
        <Route path="register" element={<Registerpage />}></Route>

        <Route path="skills/:slug" element={<ActivityGuard><StopSkill /></ActivityGuard>}></Route>

        <Route path="email-test" element={<EmailTest />}></Route>

        {/* 404 - Catch all unmatched routes */}
        <Route path="*" element={<NotFound />}></Route>

      </Routes>
    </Api>
    </div>
  ); 
}

export default App;
